/**
 * @file    IFramePage.jsx
 *
 * @author  Bryan Hoang <bryan@distributive.network>
 * @date    Sept. 2024
 */

import { useLocation } from 'react-router-dom';

import { Layout } from '@/components/Layout';

/**
 * Renders a page that uses an iframe for its content.
 */
export function IFramePage(_props)
{
  const location = useLocation();
  const page = location.pathname.split('/')[1];
  const build = dcp['dcp-build'].config.build;
  const cacheKey = import.meta.env.VITE_DCP_CACHE_KEY + (build === 'debug' ? '-' + Math.random().toString(16).slice(2) : '');
  return (
    <Layout contentClassName={page}>
      <iframe src={`/${page}/index.html?cacheKey=${cacheKey}`} title={`Main content for /${page}`} allow="fullscreen"/>
    </Layout>
  );
}
